__turbopack_context__.v({
  "close": "modal-module__VTPQJa__close",
  "content": "modal-module__VTPQJa__content",
  "dialog": "modal-module__VTPQJa__dialog",
});
